<template>
    <div id="app">
        <v-app id="inspire">

            <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
                <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
                    Ana Şirket Seçimi
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- <v-btn icon>
                    <v-icon>notifications</v-icon>
                </v-btn> -->

            </v-toolbar>

            <navi v-model="drawer"></navi>

            <div v-if="giris">
                <v-content>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                                <span class=" grey--text headline">Ana Şirket Seçimi</span>
                                <v-divider></v-divider>
                            </v-flex>


                            <div v-for="item in AnaSirketlerWiev" v-bind:key="item.index">
                                <v-flex ma-4 xs2 sm1 md1>
                                    <v-hover>
                                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                            class="mx-auto" width="300">
                                            <v-card-title>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout justify-center>
                                                            <div>

                                                                <v-layout justify-center>
                                                                    <span class="font-weight-bold grey--text title mb-2">&nbsp;
                                                                    </span>
                                                                </v-layout>

                                                                <v-layout justify-center>
                                                                    <span class="font-weight-bold grey--text title mb-2">{{item.text}}
                                                                    </span>
                                                                </v-layout>

                                                                <v-layout justify-center>
                                                                    <span class="font-weight-bold grey--text title mb-2">({{item.baglisirketler.length}}
                                                                        adet şirket)
                                                                    </span>
                                                                </v-layout>

                                                                <v-divider></v-divider>

                                                                <v-layout justify-center>
                                                                    <div class="font-weight-light grey--text caption mb-2">Üyelik
                                                                        Paketi</div>

                                                                </v-layout>

                                                                <v-layout justify-center>
                                                                    <div class="font-weight-light grey--text title mb-2">
                                                                        Bilet + Cari Hesap </div>
                                                                </v-layout>

                                                                <v-divider></v-divider>

                                                                <v-layout justify-center>
                                                                    <div v-if="item.UyelikTip =='2'" class="font-weight-light grey--text caption mb-2">Üyelik
                                                                        Bitiş Tarihi</div>
                                                                    <div v-if="item.UyelikTip=='1'" class="font-weight-light grey--text caption mb-2">Ücretsiz
                                                                        Üyelik</div>
                                                                    <div v-if="item.UyelikTip!='1' && item.UyelikTip!='2' && item.UyelikTip!='3' "
                                                                        class="font-weight-light grey--text caption mb-2">Ücretsiz
                                                                        Üyelik</div>
                                                                    <div v-if="item.UyelikTip=='3'" class="font-weight-light grey--text caption mb-2">Kalan
                                                                        Kontör Adedi</div>
                                                                </v-layout>

                                                                <v-layout v-if="item.UyelikStatus==true" justify-center>
                                                                    <div v-if="item.UyelikTip=='1' || item.UyelikTip =='2'"
                                                                        class="font-weight-light red--text title mb-2">{{item.UyelikBitis
                                                                        | dateformat}}</div>
                                                                    <div v-if="item.UyelikTip=='3'" class="font-weight-light red--text title mb-2">{{item.KalanKontor}}</div>
                                                                </v-layout>
                                                                <v-layout v-if="item.UyelikStatus==false"
                                                                    justify-center>
                                                                    <div class="font-weight-light red--text title mb-2">&nbsp;</div>
                                                                    <div class="font-weight-light red--text title mb-2">Aktif
                                                                        üyeliğiniz yok</div>
                                                                </v-layout>

                                                                <v-divider></v-divider>

                                                            </div>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 ma-1 md12>

                                                        <v-layout justify-start>

                                                            <v-flex xs2 sm2 md3>
                                                                <v-btn class="white--text" icon color="white">
                                                                    <v-icon color="grey">settings</v-icon>
                                                                </v-btn>
                                                            </v-flex>

                                                            <v-divider vertical></v-divider>

                                                            <v-flex xs8 ma-1 sm8 md8>
                                                                <v-layout justify-center>
                                                                    <v-btn block class="white--text" :disabled="!item.active"
                                                                        @click="sysLogin(item.id,item.baglisirketler)"
                                                                        color="info">

                                                                        Giriş
                                                                    </v-btn>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>

                                                    </v-flex>
                                                </v-layout>
                                            </v-card-title>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </div>

                            <v-flex @click="urunleregit()" ma-4 xs2 sm1 md1>
                                <v-hover>
                                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto"
                                        width="300">
                                        <v-card-title>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-center>
                                                        <div>

                                                            <v-layout justify-center>
                                                                <span class="font-weight-bold grey--text title mb-2">&nbsp;
                                                                </span>
                                                            </v-layout>

                                                            <v-layout justify-center>
                                                                <span class="font-weight-bold grey--text title mb-2">YENİ
                                                                    ÜRÜN EKLE
                                                                </span>
                                                            </v-layout>


                                                            <v-divider></v-divider>

                                                            <v-layout justify-center>
                                                                <div class="font-weight-light grey--text caption mb-2">
                                                                </div>

                                                            </v-layout>

                                                            <v-layout justify-center>
                                                                <div style="cursor: pointer;" class=" font-weight-light grey--text display-4
 mb-2">
                                                                    + </div>
                                                            </v-layout>
                                                            <v-divider></v-divider>
                                                            <v-layout justify-center>
                                                                <div v class="font-weight-light grey--text caption mb-2">&nbsp;</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div class="font-weight-light red--text title mb-2">&nbsp;</div>
                                                            </v-layout>


                                                        </div>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm12 ma-1 md12>
                                                    <v-layout justify-start>
                                                        <v-flex xs2 sm2 md3>
                                                        </v-flex>
                                                        <v-flex xs8 ma-1 sm8 md8>
                                                            <v-layout justify-center>

                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>

                                                </v-flex>
                                            </v-layout>
                                        </v-card-title>
                                    </v-card>
                                </v-hover>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-content>
            </div>

            <div v-if="Urunler">
                <v-content>
                    <v-container fluid>
                        <div v-if="urunekrani">
                            <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                    <v-layout justify-start>
                                        <span class=" grey--text headline">Yeni Ürün Ekleme/Yenileme</span>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                    <v-layout justify-end>
                                        <v-btn @click="sirketleredon()" flat class="white--text" color="red">
                                            <v-icon>arrow_back_ios</v-icon> Geri Dön
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-flex xs6 sm6 md6>
                                <v-radio-group v-model="sirkettipi" row>
                                    <v-radio label="Mevcut Şirket" value="0"></v-radio>
                                    <v-radio label="Yeni Şirket" value="1"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-select v-if="mevcutsirketmi" item-value="id" item-text="text" label="Ana Şirketinizi Seçiniz"
                                    autofocus persistent-hint :items="AnaSirketler" v-model="AnaSirket" bottom></v-select>
                            </v-flex>

                            <v-layout row wrap>
                                <v-flex xs12 sm12 md6>
                                    <v-layout justify-start>
                                        <span class=" grey--text headline">Faaliyette Bulunduğunuz Sektör</span>
                                    </v-layout>
                                </v-flex>

                            </v-layout>

                            <v-divider></v-divider>
                            <v-radio-group v-model="sektor" row>
                                <v-radio label="Turizm Acentası " value="0"></v-radio>
                            </v-radio-group>
                            <span class=" grey--text  headline">Üyelik Tipi</span>
                            <v-divider></v-divider>
                            <v-radio-group v-model="uyeliktipi" row>
                                <v-radio label="Süreli " value="0"></v-radio>
                                <v-radio label="Kontörlü" value="1"></v-radio>
                            </v-radio-group>
                            <span v-if="urunekrani" class=" grey--text  headline">Ürünler</span>
                            <v-divider></v-divider>
                        </div>

                        <v-layout row wrap v-if="urunekrani">
                            <div v-for="item in productshow" v-bind:key="item.index">
                                <v-flex ma-2 xs12 sm4 md3>
                                    <v-hover>
                                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                            class="mx-auto" width="300">
                                            <v-card-title>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout justify-center>
                                                            <div>
                                                                <v-layout justify-center>
                                                                    <span v-if="item.UrunTip==2" class="display-3 font-weight-bold  grey--text">{{item.Gun}}
                                                                        gün </span>
                                                                    <span v-if="item.UrunTip==3" class="display-3 font-weight-bold  grey--text">{{item.Kontor}}
                                                                    </span>
                                                                </v-layout>
                                                                <v-divider></v-divider>
                                                                <v-layout align-center="" justify-center>
                                                                    <div class="font-weight-light grey--text title mb-2">
                                                                        Bilet </div>
                                                                </v-layout>
                                                                <v-layout justify-center>
                                                                    <div class="font-weight-light grey--text title mb-2">Muhasebe</div>
                                                                </v-layout>
                                                                <v-layout justify-center>
                                                                    <div class="font-weight-light grey--text title mb-2">Otel</div>
                                                                </v-layout>
                                                                <v-layout justify-center>
                                                                    <v-btn flat color="info"> Detay</v-btn>
                                                                </v-layout>
                                                                <v-divider></v-divider>
                                                                <v-layout justify-center>
                                                                    <span class="display-1  font-weight-light red--text">{{item.Tutar
                                                                        | moneyformat}}
                                                                        ₺</span>
                                                                </v-layout>
                                                            </div>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 ma-1 md12>
                                                        <v-btn block @click="Odeme(item.UrunID,item.Tutar)" class="white--text"
                                                            color="green">
                                                            <v-icon color="white">shopping_cart</v-icon> Satın Al
                                                        </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-title>

                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </div>

                            <v-flex ma-2 xs2 sm1 md1>
                                <v-hover>
                                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto"
                                        width="300">
                                        <v-card-title>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-center>
                                                        <div>
                                                            <v-layout justify-center>

                                                                <span class="display-3 font-weight-bold  grey--text">Özel
                                                                </span>
                                                            </v-layout>
                                                            <v-divider></v-divider>
                                                            <v-layout justify-center>
                                                                <div class="font-weight-light grey--text title mb-2">
                                                                    Bilet</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div class="font-weight-light grey--text title mb-2">Muhasebe</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div class="font-weight-light grey--text title mb-2">Otel</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <v-btn flat color="info"> Detay</v-btn>
                                                            </v-layout>
                                                            <v-divider></v-divider>
                                                            <v-layout justify-center>
                                                                <span class="display-1  font-weight-light red--text">&nbsp;</span>
                                                            </v-layout>
                                                        </div>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm12 ma-1 md12>
                                                    <v-btn block class="white--text" color="red">
                                                        <v-icon color="white">call</v-icon> Bize Ulaşın
                                                    </v-btn>
                                                </v-flex>

                                            </v-layout>
                                        </v-card-title>

                                    </v-card>
                                </v-hover>
                            </v-flex>
                        </v-layout>


                        <v-layout v-if="odemeekrani" row wrap>

                            <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                    <v-layout justify-start>
                                        <span class="headline">Ödeme Yöntemi Seçimi</span>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                    <v-layout justify-end>
                                        <v-btn @click="urunleredon()" flat class="white--text" color="red">
                                            <v-icon>arrow_back_ios</v-icon> Ürün Seçimi Sayfasına Dön
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>


                            <v-flex xs12 sm12 md12>
                                <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <span class="headline"></span>
                                <v-radio-group v-model="UrunKayit.OdemeOnay" row>
                                    <v-radio label="Havale " value="false"></v-radio>
                                    <v-radio label="Kredi Kartı" value="true"></v-radio>
                                </v-radio-group>
                            </v-flex>



                            <v-flex ma-2 xs12 sm12 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-flex xs12 ma-2 v-if="kredikarti" sm6 md6>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-text-field label="Kredi Kart No" mask="####-####-####-####">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-text-field label="Kart Üzerindeki isim">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-select :items="sonkullanimAy" clearable label=" Son Kullanım Ay"
                                                            item-text="text" item-value="id"></v-select>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-select :items="sonkullanimYil" clearable label="Son Kullanım Yıl"
                                                            item-text="text" item-value="id"></v-select>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-text-field label="Güvenlik Kodu" mask="###">
                                                        </v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 v-if="!kredikarti" sm6 md6>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-center="" row align-start="">
                                                        <span class="grey--text headline">Havale Onayı</span>
                                                    </v-layout>
                                                </v-flex>

                                            </v-flex>



                                            <v-flex xs12 sm6 ma-2 md6>
                                                <v-card class="white--text">
                                                    <v-card flat="">
                                                        <v-card-actions>
                                                            <v-layout justify-center>
                                                                <div>
                                                                    <v-layout justify-center>
                                                                        <div class="font-weight-light grey--text title mb-2">&nbsp;</div>
                                                                    </v-layout>
                                                                    <v-layout justify-center>
                                                                        <span class="display-1 font-weight-bold  grey--text">Toplam
                                                                            Tutar
                                                                        </span>
                                                                    </v-layout>
                                                                    <v-divider></v-divider>
                                                                    <v-layout justify-center>
                                                                        <div class="font-weight-light red--text display-3 mb-2">
                                                                            {{toplamtutar}} ₺</div>
                                                                    </v-layout>
                                                                    <v-layout justify-center>
                                                                        <div class="font-weight-light grey--text title mb-2"></div>
                                                                    </v-layout>
                                                                    <v-layout justify-center>
                                                                        <v-btn v-if="!kredikarti" block class="white--text"
                                                                            @click="SatinAl()" color="green"> Havale
                                                                            Onayla</v-btn>
                                                                        <v-btn v-if="kredikarti" block class="white--text"
                                                                            @click="SatinAl()" color="green"> Ödeme Yap</v-btn>
                                                                    </v-layout>
                                                                    <v-layout justify-center>
                                                                        <span class="display-1  font-weight-light red--text">&nbsp;</span>
                                                                    </v-layout>
                                                                </div>
                                                            </v-layout>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-card>
                                            </v-flex>

                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                        </v-layout>


                    </v-container>
                </v-content>
            </div>




            <v-dialog v-model="dialogyenisirket" persistent max-width="400px">
                <v-card color="grey lighten-5">
                    <v-flex xs12 sm12>
                        <v-toolbar size="120px" dark color="info">


                            <v-toolbar-title>Yeni Ana Şirket</v-toolbar-title>
                        </v-toolbar>
                    </v-flex>
                    <v-flex pa-1 xs12 sm12 md12>

                        <v-layout wrap>
                            <div class="flex md12">
                                <v-text-field label="Şirket Ünvanı" v-model="yenisirketunvani"></v-text-field>
                            </div>
                        </v-layout>

                    </v-flex>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" v-if="!bekle" flat @click="sirketaciptal()">Vazgeç</v-btn>
                        <v-btn color="info" v-if="!bekle" flat @click="yenisirketac()">Kaydet</v-btn>
                        <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>



                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
            </v-snackbar>

        </v-app>
    </div>

</template>

<script>
    import auth from '../../../api/auth'
    import _ from 'underscore'
    import router from '../../../router'
    import helpers from "@/components/app/customcomp/helpers.js"
  import navi from "@/components/app/account/navigator.vue"


    export default {
        data: () => ({
            musteriidurun: null,
            pass: null,
            yedekresponse: [],
            bekle: false,
            AnaSirketlerWiev: [],
            AnaSirketler: [],
            Sirketler: [],
            AnaSirket: {},
            Sirket: {},
            giris: true,
            Urunler: false,
            urunlerlist: [],
            active: false,
            sektor: '0',
            uyeliktipi: '0',
            productshow: [],
            odemetipi: false,
            havale: true,
            kredikarti: false,
            odemeekrani: false,
            toplamtutar: 0,
            urunekrani: true,
            musteriid: null,
            dialogyenisirket: false,
            yenisirketunvani: null,
            sirkettipi: '0',
            karttipi: [{
                    id: 'M',
                    text: 'Master Card'
                },
                {
                    id: 'VI',
                    text: 'VISA'
                },
                {
                    id: 'A',
                    text: 'American Express'
                },
            ],
            sonkullanimAy: [{
                    id: '01',
                    text: '1'
                },
                {
                    id: '02',
                    text: '2'
                },
                {
                    id: '03',
                    text: '3'
                },
                {
                    id: '04',
                    text: '4'
                },
                {
                    id: '05',
                    text: '5'
                },
                {
                    id: '06',
                    text: '6'
                },
                {
                    id: '07',
                    text: '7'
                },
                {
                    id: '08',
                    text: '8'
                },
                {
                    id: '09',
                    text: '9'
                },
                {
                    id: '10',
                    text: '10'
                },
                {
                    id: '11',
                    text: '11'
                },
                {
                    id: '12',
                    text: '12'
                }
            ],
            sonkullanimYil: [
                '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015',
                '2016', '2017',
                '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
                '2029', '2030'
            ],
            dictionary: {
                custom: {
                    kartno: {
                        required: () => 'Bu alan boş bırakılamaz',
                        min: 'Kart numarası 16 haneli olmalıdır.'
                    },

                    selectkarttipi: {
                        required: () => 'lütfen seçiminizi yapınız',
                    },
                    kartcari: {
                        required: () => 'lütfen seçiminizi yapınız',
                    },
                    selectsonkullanim: {
                        required: () => 'lütfen seçiminizi yapınız',
                    },
                    selectsonkullanimyil: {
                        required: () => 'lütfen seçiminizi yapınız',
                    },

                }
            },

            itemsnavi: [{
                    icon: 'business',
                    text: 'Şirket İşlemleri',
                    to: 'anasirket',
                },
                {
                    icon: 'people',
                    text: 'Üye İşlemeleri',
                    to: 'login-uye'
                },
                {
                    icon: 'people',
                    text: 'Yetki Grupları',
                    to: 'login-yetkigruplist'
                }
            ],
            clipped: true,
            drawer: true,
            fixed: false,
            miniVariant: false,
            right: true,
            rightDrawer: false,

            UrunKayit: {
                ID: null,
                MusteriInfo: {
                    MusteriID: null,
                    MusteriKod: null
                },
                UrunInfo: {
                    UrunID: null
                },
                UrunAdet: 1,
                BaslangicTarih: null,
                BitisTarih: null,
                Kontor: null,
                KalanKontor: null,
                SatisTarihi: null,
                SatisTutar: 0,
                Aktif: null,
                OdemeOnay: 'false'
            },

            mevcutsirketmi: true,
            yenisirket: false,
            dialog: false,
            items: [{
                    icon: 'domain',
                    text: 'Şirket İşlemleri'
                },
                {
                    icon: 'contacts',
                    text: 'Üye İşlemleri'
                },
            ],


            faturainfo: [],
            newuserstatus: false,
            loginstatus: true,
            e1: 0,
            e2: true,
            e3: true,
            e4: true,
            text1: '',
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            rules: {
                required: (value) => !!value || 'Gerekli alan.',
                email: (value) => {
                    const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Hatalı e-mail.'
                }
            },
            YeniKullanici: {
                UserID: null,
                MusteriID: 0,
                KullaniciAdi: null,
                Email: null,
                Sifre: null,
                Tip: 0,
                AdSoyad: null,
                Deleted: false,
                Aktif: false,
                MusteriBilgi: [],
                OdemeOnay: false,
            },
            unvan: null,
            confirm: null,
            Credential: {
                email: '',
                password: ''
            },
            valid: true,
            errorMsg: '',
            errorAlert: false,
            AnaSirketler: [],
            Sirketler: [],
            AnaSirket: {},
            Sirket: {}
        }),
        props: {
            source: String
        },
        methods: {
            logout() {
                auth.logout()
            },

            yenisirketac() {
                this.bekle = true;

                var response1 = JSON.parse(window.localStorage.getItem('response'));

                if (this.yenisirketunvani != null && this.yenisirketunvani != '') {
                    var params = {
                        Mail: response1.Email,
                        CustomerInfo: {
                            Ad: this.yenisirketunvani
                        }
                    }

                    this.$http.post(auth.API_URL + 'api/Register/NewCustomerAdd', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                        this.text1 = response.body.ResponseMessage
                        this.snackbar = true

                        if (response.body.Status == true) {
                            this.text1 =
                                'Yeni ana şirket kayıt işleminiz tamamlandı ve şirketinize 10 günlük ücretsiz üyelik tanımlanmıştır.'
                            this.snackbar = true
                            this.dialogyenisirket = false;
                            this.sirkettipi = '0';
                            this.bekle = false;


                            var params = {
                                Email: response1.Email

                            }
                            this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
                                headers: {
                                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                                }
                            }).then((response) => {

                                  this.giris = true
                this.Urunler = false

                                    this.bekle = false;
                                    this.yedekresponse = response1
                                    window.localStorage.removeItem('response')

                                    var sirketlers = []
                                    Object.keys(response.body[0].MusteriBilgi).forEach(key => {
                                        var anasirket = {
                                            Ad: response.body[0].MusteriBilgi[key].Ad,
                                            GenelSirketler: response.body[0].MusteriBilgi[key].Sirketler,
                                            MusteriId: response.body[0].MusteriBilgi[key].MusteriID,
                                            MusteriKod: response.body[0].MusteriBilgi[key].MusteriKod
                                        }
                                        sirketlers.push(anasirket)
                                    });

                                    var newresponse = {
                                        AdSoyad: this.yedekresponse.AdSoyad,
                                        Email: this.yedekresponse.Email,
                                        MusteriDbler: sirketlers,
                                        Token: this.yedekresponse.Token,
                                        UserId: this.yedekresponse.UserId
                                    }
                                    window.localStorage.setItem('response', JSON.stringify(newresponse));

                                    this.guncelle();

                                    //yeni response oluşturuldu burda kaldı

                            }, (response) => {
                                if (response.status === 0) {
                                    this.bekle = false;

                                    this.text1 = 'Service Unavailable-WebUserList'
                                    this.snackbar = true
                                } else {
                                    this.text1 = 'Service Unavailable-WebUserList'
                                    this.snackbar = true
                                }
                            })
                        }

                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-NewCustomerAdd'
                            this.bekle = false;

                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-NewCustomerAdd'
                            this.bekle = false;

                            this.snackbar = true
                        }
                    })

                } else {
                    this.text1 = 'Lütfen şirket ünvanını giriniz..'
                    this.snackbar = true
                    this.bekle = false;

                }
            },
            sirketaciptal() {
                this.dialogyenisirket = false;
                this.sirkettipi = '0';
            },

            urunleredon() {
                this.urunekrani = true;
                this.odemeekrani = false;
            },
            sirketleredon() {
                this.Urunler = false;
                this.giris = true;
            },

            Odeme(urunid, fiyat) {

                if (this.sirkettipi == '0' && this.AnaSirket != null && this.AnaSirket && typeof (this.sirkettipi) !=
                    'object') {
                    this.UrunKayit.UrunInfo.UrunID = urunid
                    this.UrunKayit.SatisTutar = fiyat
                    this.toplamtutar = fiyat;
                    this.odemeekrani = true;
                    this.urunekrani = false;
                } else {
                    this.text1 = 'Lütfen Şirket Seçiniz'
                    this.snackbar = true
                }
            },
            SatinAl() {

                this.UrunKayit.SatisTarihi = getDateNow()

                this.UrunKayit.MusteriInfo.MusteriKod = this.musteriidurun

                var params = this.UrunKayit

                this.$http.post(auth.API_URL + 'api/Register/ProductCustomerSave', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.text1 = response.body.ResponseMessage
                    this.snackbar = true
                    if (response.body.Status == true) {


                        this.text1 = 'Ödemeniz başarılı, şirket seçimi sayfasına yönlendiriliyorsunuz'
                        this.snackbar = true

                        this.guncelle();

                        setTimeout(function () {

                            this.odemeekrani = false;
                            this.urunekrani = true;
                            this.giris = true;
                            this.Urunler = false;

                        }.bind(this), 4000)

                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    }
                })
            },
            urunleregit() {
                this.AnaSirket = null
                this.giris = false
                this.Urunler = true
                var params = {
                    ProductID: 0,
                    ProductType: 0
                }

                this.$http.post(auth.API_URL + 'api/Register/ProductList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.urunlerlist = response.body
                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.UrunTip == 2)
                            this.productshow.push(element)
                    });
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Company Get'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-Company Get'
                        this.snackbar = true
                    }
                })
            },
            sysLogin,
            getDateNow,
            guncelle,
            userlist
        },
        beforeMount: beforeMount,

    components: {
      'navi': navi},
        watch: {

            'uyeliktipi': function (value) {
                if (value == 0) {
                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.UrunTip == 2)
                            this.productshow.push(element)
                    });
                } else {

                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.UrunTip == 3)
                            this.productshow.push(element)
                    });

                }
            },
            'UrunKayit.OdemeOnay': function (value) {
                if (value == 'false') {
                    this.havale = true;
                    this.kredikarti = false;
                } else {

                    this.havale = false;
                    this.kredikarti = true;

                }
            },
            'AnaSirket': function (value) {

                if (value != null) {
                    this.musteriidurun = value
                    console.log(this.musteriidurun)
                } else {



                }
            },
            'sirkettipi': function (value) {
                if (value == '0') {
                    this.mevcutsirketmi = true;
                    this.yenisirket = false;
                    this.dialogyenisirket = false;

                } else {
                    this.dialogyenisirket = true;
                    this.mevcutsirketmi = false;
                    this.yenisirket = true;

                }
            }



        },
        filters: {
            dateformat: function (t) {
                var date = new Date(t);
                var fulldate = date.toLocaleDateString("tr-TR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                });
                return fulldate;
            },
            moneyformat: function (m) {
                return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            }
        },
    }

    function beforeMount() {


        //ana şirketleri alıyoruz

        var response1 = JSON.parse(window.localStorage.getItem('response'));


        //ManageLoad bilgilerin alıyorum kullanıcının hangi ana şirkette hangi yetkisi bulunuyor.

        var userparams = {
            Email: response1.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))

            this.pass = response.body.UserInfo.Sifre

            var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));


            var sirketlers = []

            Object.keys(response1.MusteriDbler).forEach(key => {
                var sirket = {
                    text: response1.MusteriDbler[key].Ad,
                    id: response1.MusteriDbler[key].MusteriKod,
                    baglisirketler: response1.MusteriDbler[key].GenelSirketler
                }
                sirketlers.push(sirket)
            });

            this.AnaSirketler = sirketlers;
            this.AnaSirketlerWiev = [];
            var yedeklist = []


            this.AnaSirketler.forEach(element => {
                var aktifmi = response2.AnaSirketInfo.map(function (e) {
                    return e.MusteriKod;
                }).indexOf(element.id);
                var id = element.id;
                var text = element.text;
                var baglisirket = [];
                var active = response2.AnaSirketInfo[aktifmi].Aktif
                baglisirket = element.baglisirketler

                var params = {
                    MusteriInfo: {
                        MusteriKod: element.id
                    }
                }
                this.$http.post(auth.API_URL + 'api/Register/ProductCustomerInfo', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    if (response.body.UyelikStatus != true) {
                        active = false
                    }
                    var sirket = {
                        id: id,
                        text: text,
                        UyelikBitis: response.body.UyelikBitis,
                        UyelikTip: response.body.UyelikTip,
                        KalanKontor: response.body.KalanKontor,
                        UyelikStatus: response.body.UyelikStatus,
                        baglisirketler: baglisirket,
                        active: active
                    }
                    yedeklist.push(sirket)
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    } else {

                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    }
                })
            });

            this.AnaSirketlerWiev = yedeklist


        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            }
        })
    }

    function guncelle() {

        //ana şirketleri alıyoruz

        var response1 = JSON.parse(window.localStorage.getItem('response'));


        //ManageLoad bilgilerin alıyorum kullanıcının hangi ana şirkette hangi yetkisi bulunuyor.

        var userparams = {
            Email: response1.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))
            this.pass = response.body.UserInfo.Sifre

            var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));


            var sirketlers = []

            Object.keys(response1.MusteriDbler).forEach(key => {
                var sirket = {
                    text: response1.MusteriDbler[key].Ad,
                    id: response1.MusteriDbler[key].MusteriKod,
                    baglisirketler: response1.MusteriDbler[key].GenelSirketler
                }
                sirketlers.push(sirket)
            });

            this.AnaSirketler = sirketlers;
            this.AnaSirketlerWiev = [];
            var yedeklist = []


            this.AnaSirketler.forEach(element => {
                var aktifmi = response2.AnaSirketInfo.map(function (e) {
                    return e.MusteriKod;
                }).indexOf(element.id);
                var id = element.id;
                var text = element.text;
                var baglisirket = [];
                var active = response2.AnaSirketInfo[aktifmi].Aktif
                baglisirket = element.baglisirketler

                var params = {
                    MusteriInfo: {
                        MusteriKod: element.id
                    }
                }
                this.$http.post(auth.API_URL + 'api/Register/ProductCustomerInfo', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    if (response.body.UyelikStatus != true) {
                        active = false
                    }

                    var sirket = {
                        id: id,
                        text: text,
                        UyelikBitis: response.body.UyelikBitis,
                        UyelikTip: response.body.UyelikTip,
                        KalanKontor: response.body.KalanKontor,
                        UyelikStatus: response.body.UyelikStatus,
                        baglisirketler: baglisirket,
                        active: active
                    }
                    yedeklist.push(sirket)
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    } else {

                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    }
                })
            });

            this.AnaSirketlerWiev = yedeklist


        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            }
        })
    }

    function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }

    function userlist() {

        var response = JSON.parse(window.localStorage.getItem('response'));

        var userparams = {
            Email: response.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserConnList', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserConnList'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserConnList'
                this.snackbar = true
            }
        })

    }


    function sysLogin(anasirketid, sirketler) {

        if (sirketler.length>0) {
  var response = JSON.parse(window.localStorage.getItem('response'));

        var earsiv = 0
        var efatura = 0
        this.Sirket.id = sirketler[0].SirketKodu
        this.Sirket.text = sirketler[0].SirketAdi
        this.Sirket.unvan = sirketler[0].SirketUnvani

        var sirketparams = {
            SirketKodu: this.Sirket.id
        }

        this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            earsiv = response.body.OpsiyonBilgileri.EArsiv
            efatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor

            var credentials = {
                AnaSirketKodu: anasirketid,
                SirketKodu: this.Sirket.id,
                SirketAdi: this.Sirket.text,
                SirketUnvani: this.Sirket.unvan,
                Sirketler: sirketler,
                EArsiv: earsiv,
                EFatura: efatura
            }


            window.localStorage.setItem('credentials', JSON.stringify(credentials));


            // window.localStorage.removeItem('sirketler')

            var response = JSON.parse(window.localStorage.getItem('response'));



            var credential = {
                Email: response.Email,
                Password: this.pass,
                ActiveMusteriKod: anasirketid
            }
            auth.logingiris(this, credential, this.$route.query.redirect)

        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-Company Get'
                this.snackbar = true
                this.load1 = true
                this.progress = false


            } else {

                this.text1 = 'Service Unavailable-Company Get'
                this.snackbar = true
                this.load1 = true
                this.progress = false

            }




        })



        } else {
             this.text1 = 'Ana şirkete bağlı alt şirket bulunamadı'
                this.snackbar = true
        }



    }
</script>